











import Vue, { PropType } from 'vue'
import { Spell } from '@/types'
import ShowMoreIcon from '@/components/icons/ShowMoreIcon.vue'
import ShowLessIcon from '@/components/icons/ShowLessIcon.vue'
import SpellInfo from '@/components/SpellInfo.vue'

export default Vue.extend({
  name: 'SpellSearchResult',
  data () {
    return {
      showDetails: false,
    }
  },
  components: {
    ShowMoreIcon,
    ShowLessIcon,
    SpellInfo,
  },
  props: {
    spell: {
      type: Object as PropType<Spell>,
      required: true,
    },
  },
})
